import{useCoreContext as o}from"../Context/CoreProvider.js";import r from"../Errors/AdyenCheckoutError.js";const t=()=>{const{analytics:t}=o();if(void 0===t)throw new r("SDK_ERROR","useAnalytics(): analytics module is not defined");return{analytics:t}};export{t as default};
//# sourceMappingURL=useAnalytics.js.map
